import { Stack } from '@mui/material';
import Step from './Step';
import { StepType } from './types';

type StepperProps = {
  steps: StepType[];
};

const Stepper = ({ steps }: StepperProps) => {
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      {steps.map((step, index) => (
        <Step key={index} active={step.active} completed={step.completed} />
      ))}
    </Stack>
  );
};

export default Stepper;
